import request from "@/libs/http";
export const pluginMediaMusicAlbum = (params) => request.post('/plugin/plugin-media-music-album/query-page', params) //查询歌单
export const pluginMediaMusicAlbumQueryDetail = (params) => request.post('/plugin/plugin-media-music-album/query-detail', params) //查询歌单详情
export const pluginMediaMusicInfoSubmitFailure = (params) => request.post('/plugin/plugin-media-music-info/submit-failure', params) //歌曲提交失效
export const pluginMediaMusicInfoPlayMusic = (params) => request.post('/plugin/plugin-media-music-info/play-music', params) //歌曲提交失效

